module.exports = __webpack_public_path__ + "static/media/promo-banner.2ee8ec0b.jpg";